import $ from 'jquery'
import infiniteScroll from './infinite-scroll-fake.js'
import Dotdotdot from 'dotdotdot-js'

const dataSet = {
  dataKeeper: '.data-keeper-js',
  overviewContainer: '.reports-content-container',
  overviewInfiniteScrollingMarker: '.reports-content-container',
  selector: '.reports-downloads .item-wrapper',
  fakeScrolling: true,
  waiting: 1000,
  loadingContainer: '.infinite-scrolling-animation',
  loadedItems: 10 // important! change link-download-list.ftl too
}

function init () {
  $('.link-download-list.reports-downloads').each(function () {
    let $this = createObject($(this))
    resetFilter($this)
    onChangeFilter($this)
    preFilter($(this).data('preset-year'), $(this).data('preset-topic'), $this)
    infiniteScroll($(this), 10)
    // Dropdown($(this));
    dotting($(this).get(0))
  })
}

function preFilter (preYear, preFilter, $this) {
  if (preYear !== undefined) {
    let selectYear = $this.element.find('.formRow--dropdown-select[data-id=\'filter-date\']')

    selectYear.find('option[value=\'' + preYear + '\']').attr('selected', true)
    selectYear.trigger('update').trigger('change')
  }
  if (preFilter !== undefined) {
    let selectTopic = $this.element.find('.formRow--dropdown-select[data-id=\'filter-topic\']')

    selectTopic.find('option[value=\'' + preFilter + '\']').attr('selected', true)
    selectTopic.trigger('update').trigger('change')
  }
}

function createObject (element) {
  let object = {
    element: element,
    dropdownDate: element.find('[data-id=\'filter-date\']'),
    dropdownTopic: element.find('[data-id=\'filter-topic\']'),
    resetFilter: element.find('.reports-filter-reset'),
    messageBox: element.find('.noHits'),
    messageText: element.find('.noHits .noHits-text'),
    items: element.find('.item-wrapper'),
    currentDate: null,
    currentTopic: null,
  }
  return object
}

function resetFilter ($this) {
  $this.resetFilter.on('click', () => {
    $this.dropdownDate.trigger('reset')
    $this.dropdownTopic.trigger('reset')
    $this.currentDate = $this.dropdownDate.val()
    $this.currentTopic = $this.dropdownTopic.val()
    filter($this)
  })
}

function dotting (domElement) {
  const options = {
    height: 'watch'
  }
  domElement
    .querySelectorAll('.dotdotdot')
    .forEach(el => {
      el.__dotdotdotInstance = new Dotdotdot(el, options)
    })
}

function onChangeFilter ($this) {
  $this.dropdownDate.on('change', () => {
    $this.currentDate = $this.dropdownDate.val()
    filter($this)
  })
  $this.dropdownTopic.on('change', () => {
    $this.currentTopic = $this.dropdownTopic.val()
    filter($this)
  })
}

function filter ($this) {
  let currentTopic = $this.currentTopic == null ? 'all' : $this.currentTopic
  let currentDate = $this.currentDate == null ? 'all' : $this.currentDate

  $this.messageBox.hide()

  if (currentTopic == 'all' && currentDate == 'all') {
    $this.items.attr('data-visible', false)
    $this.items.attr('data-filter-visible', true)
    $this.items.slice(0, 9)
      .attr('data-visible', true)
      .show({ effect: 'fade' })

    $($this.element).trigger('update')
  } else if (currentTopic == 'all') {
    $this.items.not('[data-date*=\'' + currentDate + '\']')
      .attr('data-filter-visible', false)
      .attr('data-visible', false)
      .hide({
        effect: 'fade',
        complete: () => {
          if ($this.items.filter('[data-date*=\'' + currentDate + '\']').length > 0) {
            $this.items.filter('[data-date*=\'' + currentDate + '\']')
              .attr('data-filter-visible', true)
              .slice(0, 9)
              .attr('data-visible', true)
              .show({ effect: 'fade' })

            $($this.element).trigger('update')
          } else {
            noHits($this, currentTopic, currentDate)
          }
        }
      })

  } else if (currentDate == 'all') {
    $this.items.not('[data-topic*=\'' + currentTopic + '\']')
      .attr('data-filter-visible', false)
      .attr('data-visible', false)
      .hide({
        effect: 'fade',
        complete: () => {
          if ($this.items.filter('[data-topic*=\'' + currentTopic + '\']').length > 0) {
            $this.items.filter('[data-topic*=\'' + currentTopic + '\']')
              .attr('data-filter-visible', true)
              .slice(0, 9)
              .attr('data-visible', true)
              .show({ effect: 'fade' })

            $($this.element).trigger('update')
          } else {
            noHits($this, currentTopic, currentDate)
          }
        }
      })
  } else {
    $this.items.not('[data-topic*=\'' + currentTopic + '\'][data-date*=\'' + currentDate + '\']')
      .attr('data-filter-visible', false)
      .attr('data-visible', false)
      .hide({
        effect: 'fade',
        complete: () => {
          if ($this.items.filter('[data-topic*=\'' + currentTopic + '\'][data-date*=\'' + currentDate + '\']').length > 0) {
            $this.items.filter('[data-topic*=\'' + currentTopic + '\'][data-date*=\'' + currentDate + '\']')
              .attr('data-filter-visible', true)
              .slice(0, 9)
              .attr('data-visible', true)
              .show({ effect: 'fade' })

            $($this.element).trigger('update')
          } else {
            noHits($this, currentTopic, currentDate)
          }
        }
      })
  }

}

function noHits ($this, currentTopic, currentDate) {
  if (currentTopic !== 'all') {
    if (currentDate !== 'all') {
      $this.messageText.html($this.messageText.data('no-hit-year-topic').replace('{topic}', currentTopic).replace('{year}', currentDate))
    } else {
      $this.messageText.html($this.messageText.data('no-hit-topic').replace('{topic}', currentTopic))
    }
  } else {
    $this.messageText.html($this.messageText.data('no-hit-year').replace('{year}', currentDate))
  }
  $this.messageBox.show()
}

export default {
  init
}
